import TimespanLegend from "./TimespanLegend.component.jsx";

export default TimespanLegend;
